import axios from "axios";
import { jwtClient } from "./authUtils";

export const REQUEST_STATION = "REQUEST_STATION";
const requestStation = () => {
  return {
    type: REQUEST_STATION,
  };
};

export const RECEIVE_STATION = "RECEIVE_STATION";
const receiveStation = (station, fetchPeriod) => {
  return {
    type: RECEIVE_STATION,
    station,
    fetchPeriod,
  };
};

export const FAILED_STATION = "FAILED_STATION";
const failedStation = () => {
  return {
    type: FAILED_STATION,
  };
};

export const BRUSH_DOMAIN_STATION = "BRUSH_DOMAIN_STATION";
function brushDomain(domain) {
  return {
    type: BRUSH_DOMAIN_STATION,
    domain,
  };
}

export const HOVER_DATE_STATION = "HOVER_DATE_STATION";
function hoverDate(hoverDate) {
  return {
    type: HOVER_DATE_STATION,
    hoverDate,
  };
}

export const TOGGLE_PIN_STATION = "TOGGLE_PIN_STATION";
function togglePin() {
  return {
    type: TOGGLE_PIN_STATION,
  };
}

export const HOVER_STATION = "HOVER_STATION";
function hovered(hovered) {
  return {
    type: HOVER_STATION,
    hovered,
  };
}

export const fetchStation = (
  apiUrl,
  stationId,
  showAllMeasurements,
  showFiveMinutesMeasurements,
  fetchPeriod
) => {
  return async (dispatch) => {
    dispatch(requestStation());
    try {
      if (!fetchPeriod) {
        var date = new Date();
        var ts = Math.round(date / 1000);
        var offset = date.getTimezoneOffset() * 60;
        fetchPeriod = [ts - offset - 60 * 60 * 24 * 60, ts - offset + 60 * 60 * 24];
      }

      var url = apiUrl + `/api/product/installation/${stationId}/hour_and_day/?format=json`;
      var d = new Date();
      var yesterday = Math.round(d / 1000) - 60 * 60 * 24;
      var end = "";

      // Assume reading measurements to end id selected date >= yesterday
      if (fetchPeriod[1] < yesterday) {
        end = "&end=" + fetchPeriod[1];
      }
      var urlExtra =
        "&start=" +
        fetchPeriod[0] +
        end +
        (showAllMeasurements === true ? "&all=true" : "") +
        (showFiveMinutesMeasurements === true ? "&five=true" : "");
      url += urlExtra;

      const response = await jwtClient.withJWT(async (jwt) => {
        return axios.get(url, {
          headers: { Authorization: "JWT " + jwt },
        });
      });

      return dispatch(receiveStation(response.data, fetchPeriod));
    } catch (err) {
      console.log(err);
      return dispatch(failedStation());
    }
  };
};

const weatherStationActions = {
  fetchStation,
  brushDomain,
  hoverDate,
  togglePin,
  hovered,
};

export default weatherStationActions;
